import _ from 'lodash';
import '../../../css/svsr_card.css'
import React, { Component } from "react";


class SRCard extends Component {
    constructor(props) {
        super(props);
    }

    render_hwim() {
        const pob = this.props.pob
        
        const cparagraph = this.props.paragraph
        const averageGuestPrice = pob.averageGuestPrice
        const totalAmount = 2 * averageGuestPrice

        return(
        <div>
            <div className="carousel-box">

    
<div className="card-image">

    <picture>
        <source
            media="(min-width:768px)"
            srcset="http://localhost:8086/images/land.jpg?$400x300$" />

        <img
            src="http://localhost:8086/images/land.jpg?$277x208$"
            alt="Interior Cabin"/>
    </picture>

</div>


<div className="card-body">

    <h3 className="card-title">
        {pob.label}
    </h3>

    <ul className="card-features">
        <li>Our most budget-friendly option</li>
        <li>A cozy {cparagraph}</li>
        <li>Perfect for long naps after an adventure-filled day</li>
    </ul>

</div>


<div className="card-footer">

    <div className="price">

        <div className="starting">
            Starting from:
        </div>

        <div className="main-price">

            <span className="amount">${pob.averageGuestPrice}</span>

            <span className="currency">
                USD
            </span>

            <span className="person">
                /person*
            </span>

        </div>

        <div className="room-price">

            ${totalAmount}

            <span className="total-price">Total/Room</span>

        </div>

        <div className="taxes">
            *Taxes &amp; fees included
        </div>

    </div>

    <div className="card-actions">

        <a className="learn-more" href="#">
            Learn more
        </a>

        <button className="book-btn">
            Book now
        </button>

    </div>

</div>

</div>

        </div>
        )
    }
    render() {
        const pob = this.props.pob
        
        
        const cparagraph = this.props.paragraph
        const averageGuestPrice = pob.averageGuestPrice
        const img_paths = pob.img_paths
        const totalAmount = 2 * averageGuestPrice

        //let srcS = `${img_paths}?$277x208$`
       // let srcsetS = `${img_paths}?$400x300$`
       
        let srcS = `${img_paths}`
        let srcsetS = `${img_paths}`

        return(
        <div>
            <div className="carousel-box">

    
<div className="card-image">

    <picture>
        <source
            media="(min-width:768px)"
            srcset={srcsetS} />

        <img
            src={srcS}
            alt="Cruise Cabin"/>
    </picture>

</div>


<div className="card-body">

    <h3 className="card-title">
        {pob.label}
    </h3>

    <ul className="card-features">
        <li>Our most budget-friendly option</li>
        <li>A cozy {cparagraph}</li>
        <li>Perfect for long naps after an adventure-filled day</li>
    </ul>

</div>


<div className="card-footer">

    <div className="price">

        <div className="starting">
            Starting from:
        </div>

        <div className="main-price">

            <span className="amount">${pob.averageGuestPrice}</span>

            <span className="currency">
                USD
            </span>

            <span className="person">
                /person*
            </span>

        </div>

        <div className="room-price">

            ${totalAmount}

            <span className="total-price">Total/Room</span>

        </div>

        <div className="taxes">
            *Taxes &amp; fees included
        </div>

    </div>

    <div className="card-actions">

        <a className="learn-more" href="#">
            Learn more
        </a>

        <button className="book-btn">
            Book now
        </button>

    </div>

</div>

</div>

        </div>
        )
    }
    /*sv end render*/

}


export default SRCard;